import { ApolloClient } from '@apollo/client';
import {
  Flex_ValidateProjectIdQueryVariables,
  Flex_ValidateProjectIdQuery,
} from '~/typings/graphql';
import { VALIDATE_PROJECT_ID as query } from './handle-project-id.queries';

export { VALIDATE_PROJECT_ID } from './handle-project-id.queries';
export const handleProjectId = async ({
  apolloClient,
  projectId,
  utilityId,
}: {
  apolloClient: ApolloClient<{}>;
  projectId: string;
  utilityId: number;
}) => {
  const { data } = await apolloClient.query<
    Flex_ValidateProjectIdQuery,
    Flex_ValidateProjectIdQueryVariables
  >({
    query,
    variables: { vnmSolarProjectId: Number(projectId), utilityId },
  });

  if (data.validation.vnmSolarProject.isValid) {
    return projectId;
  }
  return undefined;
};
